import "./../styles/skill-card.css";

import api_word from "./../assets/svg/api.svg";
import aws_word from "./../assets/svg/aws.svg";
import databases_skill_sign from "./../assets/svg/databases_skill_sign.svg"
import brackets from "./../assets/svg/brackets.svg";
import python_word from "./../assets/svg/python.svg";
import react_word from "./../assets/svg/react.svg";
import amazon2 from "./../assets/svg/stack/amazon2.svg";
import aws from "./../assets/svg/stack/aws.svg";
import celery from "./../assets/svg/stack/celery.svg";
import css from "./../assets/svg/stack/css.svg";
import digital from "./../assets/svg/stack/digital.svg";
import django from "./../assets/svg/stack/django.svg";
import docker from "./../assets/svg/stack/docker.svg";
import docusign from "./../assets/svg/stack/docusign.svg";
import facebook from "./../assets/svg/stack/facebook.svg";
import firebase from "./../assets/svg/stack/firebase.svg";
import flask from "./../assets/svg/stack/flask.svg";
import git from "./../assets/svg/stack/git.svg";
import github from "./../assets/svg/stack/github.svg";
import google from "./../assets/svg/stack/google.svg";
import heroku from "./../assets/svg/stack/heroku.svg";
import html from "./../assets/svg/stack/html.svg";
import instagram from "./../assets/svg/stack/instagram.svg";
import jinja2 from "./../assets/svg/stack/jinja2.svg";
import js from "./../assets/svg/stack/js.svg";
import linkedin from "./../assets/svg/stack/linkedin.svg";
import mongo from "./../assets/svg/stack/mongo.svg";
import mysql from "./../assets/svg/stack/mysql.svg";
import nginx from "./../assets/svg/stack/nginx.svg";
import pandas from "./../assets/svg/stack/pandas.svg";
import paypal from "./../assets/svg/stack/paypal.svg";
import postgresql from "./../assets/svg/stack/postgresql.svg";
import python from "./../assets/svg/stack/python.svg";
import rabit from "./../assets/svg/stack/rabit.svg";
import react from "./../assets/svg/stack/react.svg";
import redis from "./../assets/svg/stack/redis.svg";
import scraping from "./../assets/svg/stack/scraping.svg";
import shopify from "./../assets/svg/stack/shopify.svg";
import stripe from "./../assets/svg/stack/stripe.svg";
import tensor from "./../assets/svg/stack/tensor.svg";
import tiktok from "./../assets/svg/stack/tiktok.svg";
import helm from "./../assets/svg/stack/helm.svg"
import kubernetes from "./../assets/svg/stack/kubernetes.svg"
import azure_devops from "./../assets/svg/stack/azure_devops.svg"
import azure_aks from "./../assets/svg/stack/azure_aks.svg"
import grafana from "./../assets/svg/stack/grafana.svg"
import openai from "./../assets/svg/stack/openai.svg"
import azure_functions from "./../assets/svg/stack/azure_functions.png"
import elasticsearch from "./../assets/svg/stack/elasticsearch.png"
import mssql from "./../assets/svg/stack/mssql.png"
import gtm from "./../assets/svg/stack/gtm.png"
import seo from "./../assets/svg/stack/seo.svg"
import sso from "./../assets/svg/stack/sso.svg"
import fastapi from "./../assets/svg/stack/fastapi.svg"
import mcp from "./../assets/svg/stack/mcp.png"
import pydantic from "./../assets/svg/stack/pydantic.png"

const SkillCard = ({ name, stack, }) => {
    const stack_images = {
        "python": python,
        "react": react,
        "django": django,
        "postgreSQL": postgresql,
        "AWS": aws,
        "amazon2": amazon2,
        "CSS": css,
        "docker": docker,
        "docuSign": docusign,
        "facebook": facebook,
        "flask": flask,
        "google Search": google,
        "HTML": html,
        "instagram": instagram,
        "jinja2": jinja2,
        "JS": js,
        "linkedin": linkedin,
        "pandas": pandas,
        "paypal": paypal,
        "redis": redis,
        "shopify": shopify,
        "Amazon SP-API": amazon2,
        "stripe": stripe,
        "firebase": firebase,
        "git": git,
        "github": github,
        "tensorFlow": tensor,
        "heroku": heroku,
        "tiktok": tiktok,
        "digitalOcean": digital,
        "mySQL": mysql,
        "celery": celery,
        "MongoDB": mongo,
        "beautifulSoup": scraping,
        "RabbitMQ": rabit,
        "nginx": nginx,
        "helm": helm,
        "kubernetes": kubernetes,
        "Azure": azure_devops,
        "Azure Container Registry": azure_aks,
        "grafana": grafana,
        "OpenAI": openai,
        "Azure Durable Functions": azure_functions,
        "ElasticSearch/OpenSearch": elasticsearch,
        "Google Tag Manager": gtm,
        "MSSQL": mssql,
        "SEO": seo,
        "Single Sign-On (SSO)": sso,
        "FastAPI": fastapi,
        "MCP": mcp,
        "pydantic": pydantic,
    }
    const name_image = {
        "Backend": python_word,
        "Front-End, UI & Marketing/SEO": react_word,
        "APIs": api_word,
        "Cloud & DevOps": aws_word,
        "Knowledge": brackets,
        "Databases": databases_skill_sign,
    }

    return (

        <div className="skill-card-background">
            <span className="skill-card-name">{name}<img src={name_image[name]} className='words-small'/></span>
            <div className="d-flex flex-row justify-content-start w-100 skill-content" >
                {
                    stack.map((el, index) => {
                        return (
                            <div className='skill-span' key={index}>
                                <img className='skill-image me-2' src={stack_images[el]} />
                                <span className="skill-text">
                                    {el.charAt(0).toUpperCase() + el.slice(1)}
                                </span>
                                
                            </div>
                        )
                    })
                }
            </div>
        </div>

    );
}

export default SkillCard;